import {createSlice} from '@reduxjs/toolkit';
import Cookies from 'js-cookie';
import {getRootDomain} from '@/utils/common/url';

const initialState = {
  id: Cookies.get('eCommCartId') || null,
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setCartId(state, action) {
      const id = action.payload;
      state.id = id;
      const domain = getRootDomain(location.host);
      Cookies.set('eCommCartId', id, {
        expires: 2000,
        path: '/',
        domain,
      });
    },
  },
});

export const {setCartId} = cartSlice.actions;

export const selectCartId = (state) => state.cart.id;

export default cartSlice.reducer;
